import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BgsLeafletComponent } from './components/map/bgsLeaflet.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, BgsLeafletComponent],
  exports: [BgsLeafletComponent],
  providers: [HttpClient],
})
export class BgsLeafletModule {}
